var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlined/Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.18802 12.8136L12.8135 7.18817M9.06317 4.37544L9.49727 3.8729C10.3765 2.99376 11.569 2.49991 12.8124 2.5C14.0558 2.50009 15.2482 2.9941 16.1273 3.87337C17.0065 4.75263 17.5003 5.94512 17.5002 7.1885C17.5002 8.43188 17.0061 9.6243 16.1269 10.5034L15.6262 10.9385M10.9383 15.6264L10.5661 16.127C9.67658 17.0067 8.47605 17.5 7.22505 17.5C5.97405 17.5 4.77352 17.0067 3.884 16.127C3.44555 15.6935 3.09746 15.1773 2.85989 14.6083C2.62233 14.0393 2.5 13.4288 2.5 12.8122C2.5 12.1956 2.62233 11.5852 2.85989 11.0162C3.09746 10.4472 3.44555 9.93096 3.884 9.49742L4.37529 9.06333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.722beb9d3d7150d508ca28edeba4f207.svg";
export { ForwardRef as ReactComponent };